export { jobEducationLevelsSk } from './sk';
export { jobEducationLevelsEn } from './en';
export { jobEducationLevelsCz } from './cz';

// Helper function to get job education levels by language
import { jobEducationLevelsSk } from './sk';
import { jobEducationLevelsEn } from './en';
import { jobEducationLevelsCz } from './cz';

export function getJobEducationLevels(lang: 'sk' | 'en' | 'cz') {
  switch (lang) {
    case 'sk':
      return jobEducationLevelsSk;
    case 'en':
      return jobEducationLevelsEn;
    case 'cz':
      return jobEducationLevelsCz;
    default:
      return jobEducationLevelsSk; // fallback to Slovak
  }
}
